export const FEEDBACKS_API = "/feedbacks/";

export const QUESTIONS_API = `${FEEDBACKS_API}questions/`;

export const QUESTION_TYPES_API = `${QUESTIONS_API}types/`;

export const SURVEYS_API = `${FEEDBACKS_API}surveys/`;

export const BARESTHO_FEEDBACKS_API = `${FEEDBACKS_API}barestho-survey/`;

export const BARESTHO_FEEDBACKS_STATS_API = `${FEEDBACKS_API}barestho-survey/stats/`;

export const GET_NEW_FEEDBACKS_API = `${BARESTHO_FEEDBACKS_API}new/`;


// WEBPACK FOOTER //
// ./src/apis/feedbacks.js